var map = {
	"./cards/cat-green.svg": "b68d",
	"./cards/cat-red.svg": "6c2e",
	"./cards/cat-yellow.svg": "0b52",
	"./cards/chart-up.svg": "b607",
	"./cards/money-coin.svg": "bff2",
	"./cards/money-delivery.svg": "c474",
	"./cards/pie-chart-money.svg": "f24d",
	"./cards/piggy-bank.svg": "fed4",
	"./cards/recepit.svg": "3b66",
	"./cards/rpm-cpm.svg": "8939",
	"./cards/subscribers.svg": "0f5a",
	"./cards/videos.svg": "0f1c",
	"./cards/viewers-chart.svg": "960e",
	"./cards/viewers-compare-money.svg": "d204",
	"./cards/views.svg": "c51b",
	"./icon-48-bookmark.svg": "b6b5",
	"./icon-48-link.svg": "2335",
	"./icon-48-notification.svg": "c147",
	"./icon-48-web.svg": "52b4",
	"./icon-48-youtube.svg": "becd",
	"./icon-monetizing.svg": "5cd4",
	"./key.svg": "daf4",
	"./menu/cms.svg": "75ad",
	"./menu/compare.svg": "baca",
	"./menu/dashboard.svg": "cbf5",
	"./menu/exit.svg": "203c",
	"./menu/report.svg": "526d",
	"./menu/settings.svg": "a6d2",
	"./menu/users.svg": "0731",
	"./menu/youtube.svg": "1d05",
	"./password.svg": "b009",
	"./strikes.svg": "d097"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";